import packageJSON from "package.json";

export function version() {
    return packageJSON.version;
}
